import { call, put, takeEvery } from 'redux-saga/effects';
import { findIndex } from 'lodash';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';
import store from '../../store';

const getAccount = item => {
  if (item.is_admin) return 'Admin';
  else return 'Member';
};

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      key: item.id,
      id: item.id,
      email: item.email,
      first_name: item.first_name,
      last_name: item.last_name,
      full_name: { first_name: item.first_name, last_name: item.last_name },
      created_at: item.created_at,
      account: getAccount(item),
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getInvitations({ payload: { signal, curr_page } }) {
  try {
    const { data } = yield call(fetch, { api: api.invitations.get, params: { page: curr_page }, signal });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getInvitationsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getInvitationsFailed,
      endpoint: api.invitations.get.url
    });
  }
}

function* resendInvitation({ payload: { values, onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.invitations.resend, id: values.id });

    onSuccess && onSuccess();
    yield put(actions.resendInvitationDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.resendInvitationFailed,
      endpoint: api.invitations.resend.url
    });
  }
}

function* deleteInvitation({ payload: { values, onSuccess } }) {
  const { getState, dispatch } = store;

  try {
    const { data } = yield call(fetch, { api: api.invitations.delete, id: values.id });

    const updated = [...getState().invitations.listData.dataTable];
    const deleteIndex = findIndex(updated, x => x.id === values.id);

    if (deleteIndex !== -1) {
      updated.splice(deleteIndex, 1);

      const preparedData = {
        dataTable: prepareDataTable(updated)
      };

      dispatch(actions.getInvitationsDone(preparedData));
    }

    onSuccess && onSuccess();
    yield put(actions.deleteInvitationDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.deleteInvitationFailed,
      endpoint: api.invitations.delete.url
    });
  }
}

export const getInvitationsSaga = takeEvery(types.GET_INVITATIONS_REQUEST, getInvitations);
export const resendInvitationSaga = takeEvery(types.RESEND_INVITATION_REQUEST, resendInvitation);
export const deleteInvitationSaga = takeEvery(types.DELETE_INVITATION_REQUEST, deleteInvitation);